import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchPublicLayouts, searchPublicLayouts } from "../services/api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Pagination from "../components/Pagination";
import LayoutCard from "../components/LayoutCard";
import NotFound from "../components/NotFound";
import "../styles/Estates.css";
import "../styles/LayoutCard.css";

const Layouts = () => {
  const [layouts, setLayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [typingTimeout, setTypingTimeout] = useState(null);

  // Skeleton loader
  const LayoutSkeleton = () => <LayoutCard loading />;

  useEffect(() => {
    const getLayouts = async () => {
      setLoading(true);
      try {
        const response = await fetchPublicLayouts(currentPage, 9);
        if (response && response.success) {
          setLayouts(response.payload || []);
          setTotalPages(response.pagination?.totalPages || 1);
        } else {
          setError(response?.message || 'Failed to load layouts');
        }
      } catch (error) {
        console.error('Error fetching layouts:', error);
        setError('Failed to load layouts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    getLayouts();
  }, [currentPage]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(async () => {
        if (value.trim() === '') {
          const response = await fetchPublicLayouts(0, 9);
          if (response && response.success) {
            setLayouts(response.payload || []);
            setTotalPages(response.pagination?.totalPages || 1);
            setCurrentPage(0);
          }
        } else {
          try {
            const response = await searchPublicLayouts(value, 0, 9);
            if (response && response.success) {
              setLayouts(response.payload || []);
              setTotalPages(response.pagination?.totalPages || 1);
              setCurrentPage(0);
            }
          } catch (error) {
            console.error('Error searching layouts:', error);
            setError('Failed to search layouts. Please try again.');
          }
        }
      }, 500)
    );
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    // <div className="estate-section">
    <>
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Our Layouts</h1>
            <div className="breadcumb-menu-wrap">
              <ul className="breadcumb-menu">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Layouts</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="space-top space-extra-bottom">
        <div className="container">
          <div className="row align-items-center mb-4">
            <div className="col-lg-6">
              <div className="title-area">
                <span className="sub-title6">OUR LAYOUTS</span>
                <h2 className="sec-title">Top Layouts</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="search-area">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search layouts..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                  {loading && (
                    <span
                      className="position-absolute"
                      style={{
                        right: "60px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 4,
                      }}
                    >
                      <span className="spinner-border spinner-border-sm text-primary" />
                    </span>
                  )}
                  <button
                    className="btn btn-primary"
                    style={{
                      background: "var(--theme-color)",
                      border: "none",
                      padding: "0 25px",
                    }}
                    disabled={loading}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {loading ? (
              Array(6).fill(0).map((_, index) => (
                <LayoutSkeleton key={index} />
              ))
            ) : error ? (
              <div className="col-12 text-center">
                <div className="alert alert-danger">{error}</div>
              </div>
            ) : layouts.length === 0 ? (
              <div className="col-12">
                <NotFound message="No layouts found" showHomeLink={false} />
              </div>
            ) : (
              layouts.map((layout) => (
                <LayoutCard key={layout.id} layout={layout} />
              ))
            )}
          </div>

          {!loading && layouts.length > 0 && (
            <div className="row">
              <div className="col-12">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
    // </div>
  );
};

export default Layouts;
